module.exports = __webpack_public_path__ + "static/media/Maths.25273aa2.png";